import {$path} from "safe-routes"
import {css} from "styled-system/css"
import {VStack} from "styled-system/jsx"

import {ButtonLink} from "./ButtonLink"
import {Heading} from "./parkui-generated/heading"
import {Text} from "./parkui-generated/text"
import {AyaLogo} from "~/components/AyaLogo"

interface ErrorPageProps {
  heading: string
  details: string
  homeButtonTitle: string
  stackTrace?: string
}

export const ErrorPage = ({
  heading,
  details,
  homeButtonTitle,
  stackTrace,
}: ErrorPageProps) => (
  <div
    className={css({
      width: "100%",
      height: "100dvh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "16px",
      overflow: "auto",
    })}
  >
    <VStack gap={6} alignItems="center" maxWidth="600px">
      <AyaLogo width={200} />
      <Heading size="xl" textAlign="center">
        {heading}
      </Heading>
      <Text textAlign="center">{details}</Text>
      {stackTrace && (
        <pre
          className={css({
            overflowX: "auto",
          })}
        >
          <code>{stackTrace}</code>
        </pre>
      )}
      <ButtonLink to={$path("/")}>{homeButtonTitle}</ButtonLink>
    </VStack>
  </div>
)
